module.exports = __webpack_public_path__ + "img/logo.dc8dcf00.png";